import './Layout.scss';
import React from 'react';
import UserProfile from '../partials/layout/UserProfile';
import useTheme from '../hooks/useTheme';
import { Link, useLocation } from 'react-router-dom';

export default function Layout ({ children }) {
    const location = useLocation();
    const theme = useTheme();
    return (
        <div id="layout">
            <header id="header">
                <img src={`/${theme.name}/logo-header.png`} alt="logo" />
                <UserProfile showAvatar={false} showHi={true} showBadge={false} />
            </header>
            <nav id='navigation' className='navigation'>
                <details className='navigation-details'>
                    <summary className='navigation-details-summary'>
                        <i className="kt-menu__link-icon flaticon2-layers-1" />
                        <span className='navigation-hover-only'>Préstamos</span>
                        <i className="navigation-details-arrow navigation-hover-only kt-menu__ver-arrow la la-angle-right" />
                    </summary>
                    <div className="navigation-details-content navigation-hover-only">
                        <ul className='navigation-list'>
                            <li>
                                <Link className='navigation-link' to="/dashboard" current={location.pathname === '/dashboard' ? 'true' : undefined}>
                                    Lista de operaciones
                                </Link>
                            </li>
                        </ul>
                    </div>
                </details>
                <details className='navigation-details'>
                    <summary className='navigation-details-summary'>
                        <i className="kt-menu__link-icon flaticon2-soft-icons-1" />
                        <span className='navigation-hover-only'>Comercios</span>
                        <i className="navigation-details-arrow navigation-hover-only kt-menu__ver-arrow la la-angle-right" />
                    </summary>
                    <div className="navigation-details-content navigation-hover-only">
                        <ul className='navigation-list'>
                            <li>
                                <Link className='navigation-link' to="/commerce" current={location.pathname === '/commerce' ? 'true' : undefined}>
                                    Lista de comercios
                                </Link>
                            </li>
                            <li>
                                <Link className='navigation-link' to="/commerce-signs" current={location.pathname === '/commerce-signs' ? 'true' : undefined}>
                                    Lista de operaciones
                                </Link>
                            </li>
                            <li>
                                <Link className='navigation-link' to="/commerce-lists" current={location.pathname === '/commerce-lists' ? 'true' : undefined}>
                                    Lista de préstamos
                                </Link>
                            </li>
                        </ul>
                    </div>
                </details>
            </nav>
            {children}
        </div>
    );
}
